module.exports = __webpack_public_path__ + "static/media/fa-light-300.ef489bc9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-light-300.eot
// module id = 300
// module chunks = 0